import { Controller } from '@hotwired/stimulus'
import { api } from '../../api'

interface GetBrandsEvent extends InputEvent {
  target: HTMLSelectElement
}

export default class RepCodeController extends Controller<HTMLElement> {
  declare readonly brandTarget: HTMLSelectElement

  static targets = ['brand']

  // Public methods

  async getBrands(event: GetBrandsEvent) {
    const id = event.target.value

    if (!id) return

    const brands = await api.admin.riaOffices.findBrands({ id }).then(response => response.json)
    const fragment = new DocumentFragment()

    fragment.appendChild(this.#createOption('', 'Choose Brand'))

    brands.forEach(brand => {
      fragment.appendChild(this.#createOption(brand.id, brand.name))
    })

    this.brandTarget.replaceChildren(fragment)
  }

  // Private methods

  #createOption(value: string, text: string) {
    const option = document.createElement('option')
    option.value = value
    option.textContent = text

    return option
  }
}
